import { render, staticRenderFns } from "./ProjectIndicator.vue?vue&type=template&id=f9aedd32&"
import script from "./ProjectIndicator.vue?vue&type=script&lang=js&"
export * from "./ProjectIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ProjectIndicator.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectIndicator.vue"
export default component.exports